import { ResultListModel } from '@common-lib';

import { baseClient } from '../common';
import { RuleListModel } from './rule-list.model';
import { SearchRuleModel } from './search-rule.model';

const apiUrl = `/api/rules`;

export const ruleClient = {
  list: (model: SearchRuleModel): Promise<ResultListModel<RuleListModel>> => {
    return baseClient.body<SearchRuleModel, ResultListModel<RuleListModel>>({
      body: model,
      method: 'POST',
      url: `${apiUrl}/list`,
    });
  },
};
